<script setup lang="ts">
import { onMounted, defineEmits, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';
import SpData from '@/assets/SpData.svg';

const props = defineProps({
  template: {
    type: String,
    required: true
  }
});
const emit = defineEmits(['update:welcomeMode']);

const { t: $t } = useI18n();

onMounted(() => {
  const onClickButton = () => {
    emit('update:welcomeMode', false);
  };

  const button = document.getElementById('continueButton');
  if (button) {
    button.addEventListener('click', onClickButton);
  }
});
</script>

<template>
  <div class="welcome-root">
    <div class="welcome-wrapper" v-html="props.template"></div>
    <div class="branding">
      <div class="powered-by">{{ $t("powered_by") }}</div>
      <a alt="Studypages Data"
        href="https://www.teamscopeapp.com"
        target="_blank"
        rel="noopener noreferrer">
        <img alt="Studypages Data" :src="SpData" />
      </a>
    </div>
  </div>
</template>

<style lang="scss">
.welcome-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}
.welcome {
  &-wrapper {
    padding: 24px 80px;
  }
}
.continue-button {
  position: relative;
  overflow: hidden;
  padding: 9px 12px;
  min-width: 64px;
  border: 1px solid hsla(0, 0%, 0%, 0.25);
  border-radius: 4px;
  background-color: transparent;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 0px;
  &:hover {
    background-color: #00000026;
  }
}
.branding {
  text-align: center;

  .powered-by {
    color: #272a2e;
    font-size: 12px;
    line-height: 20px;
  }

  img {
    margin-top: 4px;
    margin-bottom: 24px;
    max-width: 200px;
  }
}
@media (max-width: 600px) {
  .welcome {
    &-wrapper {
      padding: 12px 40px;
    }
  }
}
</style>
